import * as React from "react"
import { Link } from "gatsby"

import ShareButton from "./share_button"
import BlogAuthor from "./blog_author"
import BlogRelated from "./blog_related"

import CategoryData from "../../../content/data/category.yml"

const BlogArticle= ({ post, siteUrl, relatedPosts }) => {
  const title = post.frontmatter.title
  const lastmod = post.frontmatter.lastmod
  const url = post.frontmatter.url
  const image = post.frontmatter.image
  const category = post.frontmatter.category

  return (
    <article className="blog-post">
      <header>
        <p className="mb-0 md:text-sm text-gray-600">更新日: {lastmod}</p>
        <h1 className="leading-[36px] lg:leading-[52px] mt-3 text-[28px] lg:text-[48px] font-bold">{title}</h1>
        <div className="mt-5 lg:mt-3 lg:flex justify-between items-center border-b border-slate-200 mb-5 lg:mb-3 pb-3">
          <p className="font-bold md:text-sm mb-7 lg:mb-0 capitalize">
            カテゴリー: <Link className="ml-2 px-4 py-1  border-2 border-black rounded-full hover:bg-black hover:text-white ease-out duration-300" to={`/${category}`}>{CategoryData[category]['title']}</Link>
          </p>
          <ShareButton title={title} url={`${siteUrl}/${url}`} media={image} />
        </div>
      </header>
      <section className="article__body mt-12" dangerouslySetInnerHTML={{ __html: post.html }} />
      <footer className="mt-20">
        <BlogAuthor/>
        <h2 className="mt-16 text-2xl font-bold">「{CategoryData[category]['title']}」の関連記事</h2>
        <BlogRelated posts={relatedPosts} event="click__related" />
        <div className="mt-5 py-4 flex justify-center">
          <Link className="ml-2 px-6 py-3 font-bold text-lg border-2 border-black rounded-full hover:bg-black hover:text-white ease-out duration-300" to={`/${category}`}>このカテゴリーの記事一覧を見る</Link>
        </div>
      </footer>
    </article>
  )
}

export default BlogArticle